
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3322_25381)"}},[_c('path',{attrs:{"d":"M10.6 16.454l-.278 2.154c0 .196.092.392.37.392h2.595c.186 0 .371-.196.371-.392l-.278-2.154c0-.195.093-.391.278-.391h4.263c1.946 0 3.522-1.958 2.966-4.112-.37-1.469-1.668-2.447-3.059-2.35-.092-1.174-1.019-2.056-2.131-2.056-.463 0-.927.196-1.297.49C13.75 6.273 12.082 5 10.136 5 7.634 5 5.688 7.056 5.502 9.601 4.112 9.895 3 11.168 3 12.832c0 1.762 1.39 3.23 3.058 3.23h4.264c.185 0 .37.197.278.392z","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3322_25381"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    